export function useSearchableSelector() {
    const initSearchableSelector = (elementId, config = {}) => {
        const selectElement = document.getElementById(elementId)
        if (!selectElement) {
            console.warn(`Select element with ID "${elementId}" not found.`)
            return
        }

        try {
            selectElement.selectr = new Selectr(selectElement, {
                renderOption: option => option.textContent,
                ...config, // allow custom config overrides
            })

            return selectElement.selectr;
        } catch (e) {
            console.error(`Selector initialization failed for #${elementId}:`, e.message)
        }
    }

    return { initSearchableSelector }
}
